import { Grid, type SxProps } from "@mui/material";
import { type PropsWithChildren } from "react";
import { ResponsiveGridNumbers } from "../grid-container";
import { type OptionalClassName } from "../../utils/types";

export const GridChild = ({
  size,
  children,
  className,
  sx,
}: OptionalClassName<
  PropsWithChildren<{ size: ResponsiveGridNumbers; sx?: SxProps }>
>) => {
  return (
    <Grid size={size} className={className} sx={sx}>
      {children}
    </Grid>
  );
};
